// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12361(1758b2887d)-C16/04/2026-17:22:55-B16/04/2026-17:51:11' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12361(1758b2887d)-C16/04/2026-17:22:55-B16/04/2026-17:51:11",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12361",
  shortHash: "1758b2887d",
  longHash: "1758b2887d133a02d40e99fcb9f0286490b42dde",
  dateCommit: "16/04/2026-17:22:55",
  dateBuild: "16/04/2026-17:51:11",
  buildType: "Ansible",
  } ;
